import React, { Component } from 'react'
import styled from 'styled-components'
import Dropdown from 'components/UI/Dropdown'
import TextInput from 'components/UI/TextInput'
import { MetadataObj } from 'store/types'
import { IForm } from '../EstimateForm'

interface Props {
  patients?: object[]
  errors: MetadataObj
  onChangeInput: (name: string, value: string| null) => void
  OnRemoveElement?: (id: string) => void
  form: IForm
}

class PayerInfo extends Component<Props> {
  render() {
    const {
      patients,
      errors,
      onChangeInput,
      form: { payer, memberId }
    } = this.props

    console.log(payer);
    return (
      <Form>
        <div>
          <FormTitle>
            <h2>Insurance Information</h2>
          </FormTitle>
          <Dropdown
            name={'payer'}
            value={payer}
            options={patients}
            onSelect={onChangeInput}
            label={'Insurance'}
            placeholder={'Select Insurance'}
            tooltipText={'Your primary insurance provider'}
          />
          {payer.value && payer.requiredMemberId &&
          <TextInput
            name={'memberId'}
            label={'Member ID'}
            placeholder={'Enter Member ID'}
            value={memberId ? memberId : ''}
            tooltipText={'Member ID from your Health Insurance ID card'}
            errorLabel={errors.memberId || ''}
            handleChange={onChangeInput}
          />}
        </div>
      </Form>
    )
  }
}

export default PayerInfo

const FormTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;

  h2 {
    margin-right: 0.4rem;
  }
`
const Form = styled.div`
  max-width: 560px;
`
